import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { BrowserRouter } from "react-router-dom";

createRoot(document.getElementById("root")!).render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
);

if ("requestIdleCallback" in window) {
  requestIdleCallback(() => {
    import("./effects.css");
  });
} else {
  setTimeout(() => {
    import("./effects.css");
  }, 200);
}
